import { Routes } from '@angular/router';
import { AuthGuard } from '@core/services/auth-guard.service';
import { PlatformLinkCreatorComponent } from '@shared/components/platform-tool/platform-link-creator/platform-link-creator.component';
import { PlatformToolContainerComponent } from '@shared/components/platform-tool/platform-tool-container/platform-tool-container.component';
import { ComingSoonContentComponent } from '@shared/components/coming-soon/coming-soon-content/coming-soon-content.component';
import { GtcLibraryComponent } from '@features/global-tax-calculator/components/gtc-library/gtc-library.component';
import { SummaryRulesComparisonComponent } from '@features/dac6-reporter/components/summary-rules-comparison/summary-rules-comparison.component';
import { CbcExchangeStatusComponent } from './components/cbc-exchange-status/cbc-exchange-status.component';


export const itcRoutes: Routes = [
  {
    path: 'itc/dashboard',
    component: PlatformLinkCreatorComponent,
    canActivate: [AuthGuard]
  },
  // this routes for tile view
  {
    path: 'itc/analytics',
    component: ComingSoonContentComponent,
    canActivate: [AuthGuard]
  },
  {
    path: 'itc/analytics/template-view/:magicLinkId',
    component: PlatformToolContainerComponent,
    canActivate: [AuthGuard]
  },
  {
    path: 'itc/analytics/:magicLinkId',
    component: PlatformToolContainerComponent,
    canActivate: [AuthGuard]
  },
  // tile view Ends
  {
    path: 'itc/analytics/report-view',
    component: PlatformLinkCreatorComponent,
    canActivate: [AuthGuard]
  },
  {
    path: 'itc/analytics/report-view/:magicLinkId',
    component: PlatformToolContainerComponent,
    canActivate: [AuthGuard]
  },
  {
    path: 'itc/analyticsV2',
    component: PlatformLinkCreatorComponent,
    canActivate: [AuthGuard]
  },
  {
    path: 'itc/library/:category',
    component: GtcLibraryComponent,
    canActivate: [AuthGuard]
  },
  {
    path: 'itc/library/compliance',
    component: ComingSoonContentComponent,
    canActivate: [AuthGuard]
  },
  {
    path: 'itc/library/forms',
    component: ComingSoonContentComponent,
    canActivate: [AuthGuard]
  },
  {
    path: 'itc/planning',
    component: PlatformLinkCreatorComponent,
    canActivate: [AuthGuard]
  },
  {
    path: 'itc/planning/:magicLinkId',
    component: PlatformToolContainerComponent,
    canActivate: [AuthGuard]
  },
  {
    path: 'gmt/planning/eat/:magicLinkId',
    component: ComingSoonContentComponent,
    canActivate: [AuthGuard]
  },
  {
    path: 'itc/filing',
    component: ComingSoonContentComponent,
    canActivate: [AuthGuard]
  },
  {
    path: 'itc/scenarios',
    component: PlatformLinkCreatorComponent,
    canActivate: [AuthGuard]
  },
  {
    path: 'itc/scenarios/filter',
    component: PlatformLinkCreatorComponent
  },
  {
    path     : 'itc/scenarios/add-filter/:platformLinkId',
    component: PlatformLinkCreatorComponent
  },
  {
    path     : 'cbc/supported-countries',
    component: PlatformLinkCreatorComponent,
    canActivate: [AuthGuard]
  },
  {
    path: 'itc/scenarios/eat/:magicLinkId',
    component: PlatformToolContainerComponent
  },
  {
    path: 'itc/scenarios/manage-entities/:magicLinkId',
    component: PlatformToolContainerComponent,
    canActivate: [AuthGuard]
  },
  {
    path: 'itc/scenarios/manage-entities/eat/:magicLinkId',
    component: PlatformToolContainerComponent,
  },
  {
    path: 'itc/scenarios/manage-entity-changes/:magicLinkId',
    component: PlatformToolContainerComponent,
    canActivate: [AuthGuard]
  },
  {
    path: 'itc/scenarios/manage-entity-changes/eat/:magicLinkId',
    component: PlatformToolContainerComponent,
  },
  {
    path: 'itc/scenarios/manage-transactions/:magicLinkId',
    component: PlatformToolContainerComponent,
    canActivate: [AuthGuard]
  },
  {
    path: 'itc/scenarios/manage-transactions/eat/:magicLinkId',
    component: PlatformToolContainerComponent,
  },
  {
    path: 'itc/scenarios/:magicLinkId',
    component: PlatformToolContainerComponent,
    canActivate: [AuthGuard]
  },
  {
    path: 'itc/scenarios/desktop/:magicLinkId',
    component: PlatformToolContainerComponent,
    canActivate: [AuthGuard]
  },
  {
    path: 'itc/scenarios/open-calculator/:magicLinkId',
    component: PlatformToolContainerComponent
  },
  {
    path: 'itc/scenarios/open-calculator/eat/:magicLinkId',
    component: PlatformToolContainerComponent
  },
  {
    path: 'itc/scenarios/open-calculator/data-extractor/:magicLinkId',
    component: PlatformToolContainerComponent
  },
  {
    path: 'itc/scenarios/open-calculator/data-extractor/eat/:magicLinkId',
    component: PlatformToolContainerComponent
  },
  {
    path: 'itc/scenarios/:scenarioId/:magicLinkId',
    component: PlatformToolContainerComponent,
    canActivate: [AuthGuard]
  }
];

export const globalMinimumTaxRoutes: Routes = [
  {
    path: 'gmt/dashboard',
    component: PlatformLinkCreatorComponent,
    canActivate: [AuthGuard]
  },
  // this routes for tile view
  {
    path: 'gmt/analytics',
    component: PlatformLinkCreatorComponent,
    canActivate: [AuthGuard]
  },
  {
    path: 'gmt/analytics/template-view/:magicLinkId',
    component: PlatformToolContainerComponent,
    canActivate: [AuthGuard]
  },
  {
    path: 'gmt/scenarios/country-tracker-analytics/:magicLinkId',
    component: PlatformToolContainerComponent,
    canActivate: [AuthGuard]
  },
  {
    path: 'gmt/scenarios/admin-rule-analytics/:magicLinkId',
    component: PlatformToolContainerComponent,
    canActivate: [AuthGuard]
  },
  {
    path: 'gmt/analytics/:magicLinkId',
    component: PlatformToolContainerComponent,
    canActivate: [AuthGuard]
  },
  // tile view Ends
  {
    path: 'gmt/analytics/report-view',
    component: PlatformLinkCreatorComponent,
    canActivate: [AuthGuard]
  },
  {
    path: 'gmt/analytics/report-view/:magicLinkId',
    component: PlatformToolContainerComponent,
    canActivate: [AuthGuard]
  },
  {
    path: 'gmt/analyticsV2',
    component: PlatformLinkCreatorComponent,
    canActivate: [AuthGuard]
  },
  /** GMT Library Routes **/
  {
    path: 'gmt/library/summary-rules',
    component: PlatformLinkCreatorComponent
  }, {
    path: 'eat/gmt/library/summary-rules',
    component: PlatformLinkCreatorComponent
  },
  {
    path: 'gmt/library/summary-rules/compare',
    component: SummaryRulesComparisonComponent
  },
  {
    path: 'gmt/library/summary-rules/eat/:magicLinkId',
    component: PlatformToolContainerComponent
  },
  {
    path: 'gmt/library/taxnews',
    component: PlatformLinkCreatorComponent,
    canActivate: [AuthGuard]
  },
  {
    path: 'gmt/library/country-analysis/comparison',
    component: PlatformLinkCreatorComponent,
    canActivate: [AuthGuard]
  },
  {
    path: 'gmt/library/country-analysis',
    component: PlatformLinkCreatorComponent,
    canActivate: [AuthGuard]
  },
  {
    path: 'gmt/library/country-analysis/:countryCode',
    component: PlatformLinkCreatorComponent,
    canActivate: [AuthGuard]
  },
  {
    path: 'gmt/library/country-analysis/:countryCode/:categoryId',
    component: PlatformLinkCreatorComponent,
    canActivate: [AuthGuard]
  },
  {
    path: 'gmt/library/oecd-materials',
    component: PlatformLinkCreatorComponent,
    canActivate: [AuthGuard]
  },
  {
    path: 'gmt/library/country-heatmap',
    component: PlatformLinkCreatorComponent,
    canActivate: [AuthGuard]
  },
  {
    path: 'gmt/library/oecd-materials/:countryCode',
    component: PlatformLinkCreatorComponent,
    canActivate: [AuthGuard]
  },
  {
    path: 'gmt/library/oecd-materials/:countryCode/:categoryId',
    component: PlatformLinkCreatorComponent,
    canActivate: [AuthGuard]
  },
  {
    path: 'gmt/library/country-materials',
    component: PlatformLinkCreatorComponent,
    canActivate: [AuthGuard]
  },
  {
    path: 'gmt/library/country-materials/:countryCode',
    component: PlatformLinkCreatorComponent,
    canActivate: [AuthGuard]
  },
  {
    path: 'gmt/library/country-materials/:countryCode/:categoryId',
    component: PlatformLinkCreatorComponent,
    canActivate: [AuthGuard]
  },
  {
    path: 'gmt/library/reference-materials',
    component: PlatformLinkCreatorComponent,
    canActivate: [AuthGuard]
  },
  {
    path: 'gmt/library/reference-materials/:countryCode',
    component: PlatformLinkCreatorComponent,
    canActivate: [AuthGuard]
  },
  {
    path: 'gmt/library/reference-materials/:countryCode/:categoryId',
    component: PlatformLinkCreatorComponent,
    canActivate: [AuthGuard]
  },
  {
    path: 'gmt/library/compliance',
    component: ComingSoonContentComponent,
    canActivate: [AuthGuard]
  },
  {
    path: 'gmt/library/forms',
    component: ComingSoonContentComponent,
    canActivate: [AuthGuard]
  },
  {
    path: 'gmt/library/forms',
    component: ComingSoonContentComponent,
    canActivate: [AuthGuard]
  },
  {
    path: 'gmt/planning',
    component: PlatformLinkCreatorComponent,
    canActivate: [AuthGuard]
  },
  {
    path: 'gmt/planning/:magicLinkId',
    component: PlatformToolContainerComponent,
    canActivate: [AuthGuard]
  },
  {
    path: 'gmt/planning/eat/:magicLinkId',
    component: PlatformToolContainerComponent,
    canActivate: [AuthGuard]
  },
  {
    path: 'gmt/filing',
    component: ComingSoonContentComponent,
    canActivate: [AuthGuard]
  },
  {
    path: 'gmt/scenarios',
    component: PlatformLinkCreatorComponent,
    canActivate: [AuthGuard]
  },
  {
    path: 'gmt/scenarios/filter',
    component: PlatformLinkCreatorComponent
  },
  {
    path     : 'gmt/scenarios/add-filter/:platformLinkId',
    component: PlatformLinkCreatorComponent
  },
  {
    path: 'gmt/scenarios/eat/:magicLinkId',
    component: PlatformToolContainerComponent
  },
  {
    path: 'gmt/scenarios/manage-entities/:magicLinkId',
    component: PlatformToolContainerComponent,
    canActivate: [AuthGuard]
  },
  {
    path: 'gmt/scenarios/manage-entities/eat/:magicLinkId',
    component: PlatformToolContainerComponent,
  },
  {
    path: 'gmt/scenarios/manage-entity-changes/:magicLinkId',
    component: PlatformToolContainerComponent,
    canActivate: [AuthGuard]
  },
  {
    path: 'gmt/scenarios/manage-entity-changes/eat/:magicLinkId',
    component: PlatformToolContainerComponent,
  },
  {
    path: 'gmt/scenarios/manage-transactions/:magicLinkId',
    component: PlatformToolContainerComponent,
    canActivate: [AuthGuard]
  },
  {
    path: 'gmt/scenarios/manage-transactions/eat/:magicLinkId',
    component: PlatformToolContainerComponent,
  },
  {
    path: 'gmt/scenarios/country-tracker/:magicLinkId',
    component: PlatformToolContainerComponent
  },
  {
    path: "gmt/scenarios/country-tracker-comparison-analytics/:magicLinkId",
    component: PlatformToolContainerComponent,
    canActivate: [AuthGuard],
  },
  {
    path: 'itc/scenarios/manage-scenarios/:magicLinkId',
    component: PlatformToolContainerComponent
  },
  {
    path: 'itc/scenarios/:projectId/comparison-reports/:magicLinkId',
    component: PlatformToolContainerComponent
  },
  {
    path: 'gmt/scenarios/:magicLinkId',
    component: PlatformToolContainerComponent,
    canActivate: [AuthGuard]
  },
  {
    path: 'gmt/scenarios/desktop/:magicLinkId',
    component: PlatformToolContainerComponent,
    canActivate: [AuthGuard]
  },
  {
    path: 'gmt/scenarios/pillar2-compliance-analytic/:magicLinkId',
    component: PlatformToolContainerComponent
  },
  {
    path: 'gmt/scenarios/open-calculator/:magicLinkId',
    component: PlatformToolContainerComponent
  },
  {
    path: 'gmt/scenarios/diagnostic-report-open-calculator/:magicLinkId',
    component: PlatformToolContainerComponent
  },
  {
    path: 'gmt/scenarios/open-calculator/eat/:magicLinkId',
    component: PlatformToolContainerComponent
  },
  {
    path: 'gmt/scenarios/open-calculator/data-extractor/:magicLinkId',
    component: PlatformToolContainerComponent
  },
  {
    path: 'gmt/scenarios/open-calculator/data-extractor/eat/:magicLinkId',
    component: PlatformToolContainerComponent
  },
  {
    path: 'gmt/scenarios/form/:FormId',
    component: PlatformLinkCreatorComponent,
    canActivate: [AuthGuard]
  },
  {
    path: 'gmt/scenarios/:scenarioId/:magicLinkId',
    component: PlatformToolContainerComponent,
    canActivate: [AuthGuard]
  },
  {
    path: 'gmt/scenarios/otp/:magicLinkId',
    component: PlatformToolContainerComponent,
    canActivate: [AuthGuard]
  }
];

export const txpRoutes: Routes = [
  {
    path: 'txp/analytics',
    component: PlatformLinkCreatorComponent,
    canActivate: [AuthGuard]
  },
  {
    path: 'txp/scenarios',
    component: PlatformLinkCreatorComponent,
    canActivate: [AuthGuard]
  },
  {
    path: 'txp/scenarios/filter',
    component: PlatformLinkCreatorComponent
  },
  {
    path: 'txp/scenarios/add-filter/:platformLinkId',
    component: PlatformLinkCreatorComponent
  },
  {
    path: 'eat-txp',
    component: PlatformToolContainerComponent,
    canActivate: [AuthGuard]
  },
  {
    path: 'txp/scenarios/eat/:magicLinkId',
    component: PlatformToolContainerComponent,
    canActivate: [AuthGuard]
  },
  {
    path: 'txp/scenarios/:magicLinkId',
    component: PlatformToolContainerComponent,
    canActivate: [AuthGuard]
  },
  {
    path: 'txp/scenarios/open-calculator/:magicLinkId',
    component: PlatformToolContainerComponent
  },
  {
    path: 'txp/scenarios/manage-entities/:magicLinkId',
    component: PlatformToolContainerComponent,
    canActivate: [AuthGuard]
  },
  {
    path: 'txp/scenarios/manage-entity-changes/:magicLinkId',
    component: PlatformToolContainerComponent,
    canActivate: [AuthGuard]
  },
  {
    path: 'txp/configuration',
    component: PlatformLinkCreatorComponent,
    canActivate: [AuthGuard]
  },
  {
    path: 'eat/txp',
    component: PlatformLinkCreatorComponent
  }
];

export const cbcRoutes: Routes = [
  {
    path: 'cbc/dashboard',
    component: PlatformLinkCreatorComponent,
    canActivate: [AuthGuard]
  },
  // this routes for tile view
  {
    path: 'cbc/analytics',
    component: PlatformLinkCreatorComponent,
    canActivate: [AuthGuard]
  },
  {
    path: 'cbc/analytics/template-view/:magicLinkId',
    component: PlatformToolContainerComponent,
    canActivate: [AuthGuard]
  },
  {
    path: 'cbc/analytics/:magicLinkId',
    component: PlatformToolContainerComponent,
    canActivate: [AuthGuard]
  },
  // tile view Ends
  {
    path: 'cbc/analytics/report-view',
    component: PlatformLinkCreatorComponent,
    canActivate: [AuthGuard]
  },
  {
    path: 'cbc/analytics/report-view/:magicLinkId',
    component: PlatformToolContainerComponent,
    canActivate: [AuthGuard]
  },
  {
    path: 'cbc/analyticsV2',
    component: PlatformLinkCreatorComponent,
    canActivate: [AuthGuard]
  },
  // {
  //   path: 'cbc/library/:category',
  //   component: GtcLibraryComponent,
  //   canActivate: [AuthGuard]
  // },
  {
    path: 'cbc/library/taxnews',
    component: PlatformLinkCreatorComponent,
    canActivate: [AuthGuard]
  },
  {
    path: 'cbc/library/taxnews/article',
    component: PlatformLinkCreatorComponent,
    canActivate: [AuthGuard]
  },
  {
    path: 'cbc/library/exchange',
    component: PlatformLinkCreatorComponent,
    canActivate: [AuthGuard]
  },
  {
    path: 'cbc/library/oecd-materials',
    component: PlatformLinkCreatorComponent,
    canActivate: [AuthGuard]
  },
  {
    path    : 'cbc/library/oecd-materials/:countryCode',
    component: PlatformLinkCreatorComponent,
    canActivate: [AuthGuard]
  },
  {
    path    : 'cbc/library/oecd-materials/:countryCode/:categoryId',
    component: PlatformLinkCreatorComponent,
    canActivate: [AuthGuard]
  },
    {
    path: 'cbc/library/eu-materials',
    component: PlatformLinkCreatorComponent,
    canActivate: [AuthGuard]
  },
  {
    path    : 'cbc/library/eu-materials/:countryCode',
    component: PlatformLinkCreatorComponent,
    canActivate: [AuthGuard]
  },
  {
    path    : 'cbc/library/eu-materials/:countryCode/:categoryId',
    component: PlatformLinkCreatorComponent,
    canActivate: [AuthGuard]
  },
  {
    path: 'cbc/library/compliance',
    component: ComingSoonContentComponent,
    canActivate: [AuthGuard]
  },
  {
    path: 'cbc/library/forms',
    component: ComingSoonContentComponent,
    canActivate: [AuthGuard]
  },
  {
    path: 'cbc/planning',
    component: PlatformLinkCreatorComponent,
    canActivate: [AuthGuard]
  },
  {
    path: 'cbc/planning/:magicLinkId',
    component: PlatformToolContainerComponent,
    canActivate: [AuthGuard]
  },
  {
    path: 'cbc/filing',
    component: PlatformLinkCreatorComponent,
    canActivate: [AuthGuard]
  },
  {
    path: 'cbc/scenarios',
    component: PlatformLinkCreatorComponent,
    canActivate: [AuthGuard]
  },
  {
    path: 'cbc/scenarios/filter',
    component: PlatformLinkCreatorComponent
  },
  {
    path     : 'cbc/scenarios/add-filter/:platformLinkId',
    component: PlatformLinkCreatorComponent
  },
  {
    path     : 'cbc/compliance',
    component: PlatformLinkCreatorComponent,
    canActivate: [AuthGuard]
  },
  {
    path: 'cbc/forms',
    component: PlatformLinkCreatorComponent,
    canActivate: [AuthGuard]
  },
  {
    path: 'cbc/forms/:magicLinkId',
    component: PlatformToolContainerComponent,
    canActivate: [AuthGuard]
  },
  {
    path: 'cbc/compliance/changes',
    component: PlatformLinkCreatorComponent,
    canActivate: [AuthGuard]
  },
  {
    path: 'cbc/compliance/edit-cbc-required/:magicLinkId',
    component: PlatformToolContainerComponent,
    canActivate: [AuthGuard]
  },
  {
    path: 'cbc/scenarios/eat/:magicLinkId',
    component: PlatformToolContainerComponent
  },
  {
    path: 'cbc/scenarios/manage-entities/:magicLinkId',
    component: PlatformToolContainerComponent,
    canActivate: [AuthGuard]
  },
  {
    path: 'cbc/scenarios/manage-entities/eat/:magicLinkId',
    component: PlatformToolContainerComponent,
  },
  {
    path: 'cbc/scenarios/manage-entity-changes/:magicLinkId',
    component: PlatformToolContainerComponent,
    canActivate: [AuthGuard]
  },
  {
    path: 'cbc/scenarios/manage-entity-changes/eat/:magicLinkId',
    component: PlatformToolContainerComponent,
  },
  {
    path: 'cbc/scenarios/manage-transactions/:magicLinkId',
    component: PlatformToolContainerComponent,
    canActivate: [AuthGuard]
  },
  {
    path: 'cbc/scenarios/manage-transactions/eat/:magicLinkId',
    component: PlatformToolContainerComponent,
  },
  {
    path: 'cbc/scenarios/:magicLinkId',
    component: PlatformToolContainerComponent,
    canActivate: [AuthGuard]
  },
  {
    path: 'cbc/scenarios/desktop/:magicLinkId',
    component: PlatformToolContainerComponent,
    canActivate: [AuthGuard]
  },
  {
    path: 'cbc/scenarios/open-calculator/:magicLinkId',
    component: PlatformToolContainerComponent
  },
  {
    path: 'cbc/scenarios/open-calculator/eat/:magicLinkId',
    component: PlatformToolContainerComponent
  },
  {
    path: 'cbc/scenarios/open-calculator/data-extractor/:magicLinkId',
    component: PlatformToolContainerComponent
  },
  {
    path: 'cbc/scenarios/open-calculator/data-extractor/eat/:magicLinkId',
    component: PlatformToolContainerComponent
  },
  {
    path: 'cbc/scenarios/form/:FormId',
    component: PlatformLinkCreatorComponent,
    canActivate: [AuthGuard]
  },
  {
    path: 'cbc/scenarios/:scenarioId/:magicLinkId',
    component: PlatformToolContainerComponent,
    canActivate: [AuthGuard]
  }
];

export const pcbcRoutes: Routes = [
  // this routes for tile view
  {
    path: 'pcbc/analytics',
    component: ComingSoonContentComponent,
    canActivate: [AuthGuard]
  },
  {
    path: 'pcbc/analytics/template-view/:magicLinkId',
    component: PlatformToolContainerComponent,
    canActivate: [AuthGuard]
  },
  {
    path: 'pcbc/analytics/:magicLinkId',
    component: PlatformToolContainerComponent,
    canActivate: [AuthGuard]
  },
  // tile view Ends
  {
    path: 'pcbc/analytics/report-view',
    component: PlatformLinkCreatorComponent,
    canActivate: [AuthGuard]
  },
  {
    path: 'pcbc/analytics/report-view/:magicLinkId',
    component: PlatformToolContainerComponent,
    canActivate: [AuthGuard]
  },
  {
    path: 'pcbc/analyticsV2',
    component: PlatformLinkCreatorComponent,
    canActivate: [AuthGuard]
  },
  /*{
    path: 'pcbc/library/:category',
    component: GtcLibraryComponent,
    canActivate: [AuthGuard]
  },
  {
    path: 'pcbc/library/compliance',
    component: ComingSoonContentComponent,
    canActivate: [AuthGuard]
  },
  {
    path: 'pcbc/library/forms',
    component: ComingSoonContentComponent,
    canActivate: [AuthGuard]
  },
  {
    path: 'pcbc/planning',
    component: PlatformLinkCreatorComponent,
    canActivate: [AuthGuard]
  },
  {
    path: 'pcbc/planning/:magicLinkId',
    component: PlatformToolContainerComponent,
    canActivate: [AuthGuard]
  },
  {
    path: 'pcbc/filing',
    component: PlatformLinkCreatorComponent,
    canActivate: [AuthGuard]
  },*/
  {
    path: 'pcbc/scenarios',
    component: PlatformLinkCreatorComponent,
    canActivate: [AuthGuard]
  },
  {
    path: 'pcbc/scenarios/filter',
    component: PlatformLinkCreatorComponent
  },
  {
    path     : 'pcbc/scenarios/add-filter/:platformLinkId',
    component: PlatformLinkCreatorComponent
  },
  /*{
    path     : 'pcbc/compliance',
    component: PlatformLinkCreatorComponent,
    canActivate: [AuthGuard]
  },
  {
    path: 'pcbc/forms',
    component: PlatformLinkCreatorComponent,
    canActivate: [AuthGuard]
  },
  {
    path: 'pcbc/forms/:magicLinkId',
    component: PlatformToolContainerComponent,
    canActivate: [AuthGuard]
  },
  {
    path: 'pcbc/compliance/changes',
    component: PlatformLinkCreatorComponent,
    canActivate: [AuthGuard]
  },
  {
    path: 'pcbc/compliance/edit-cbc-required/:magicLinkId',
    component: PlatformToolContainerComponent,
    canActivate: [AuthGuard]
  },*/
  {
    path: 'pcbc/scenarios/eat/:magicLinkId',
    component: PlatformToolContainerComponent
  },
  {
    path: 'pcbc/scenarios/manage-entities/:magicLinkId',
    component: PlatformToolContainerComponent,
    canActivate: [AuthGuard]
  },
  {
    path: 'pcbc/scenarios/manage-entities/eat/:magicLinkId',
    component: PlatformToolContainerComponent,
  },
  {
    path: 'pcbc/scenarios/manage-transactions/:magicLinkId',
    component: PlatformToolContainerComponent,
    canActivate: [AuthGuard]
  },
  {
    path: 'pcbc/scenarios/manage-transactions/eat/:magicLinkId',
    component: PlatformToolContainerComponent,
  },
  {
    path: 'pcbc/scenarios/:magicLinkId',
    component: PlatformToolContainerComponent,
    canActivate: [AuthGuard]
  },
  {
    path: 'pcbc/scenarios/desktop/:magicLinkId',
    component: PlatformToolContainerComponent,
    canActivate: [AuthGuard]
  },
  {
    path: 'pcbc/scenarios/open-calculator/:magicLinkId',
    component: PlatformToolContainerComponent
  },
  {
    path: 'pcbc/scenarios/open-calculator/eat/:magicLinkId',
    component: PlatformToolContainerComponent
  },
  {
    path: 'pcbc/scenarios/open-calculator/data-extractor/:magicLinkId',
    component: PlatformToolContainerComponent
  },
  {
    path: 'pcbc/scenarios/open-calculator/data-extractor/eat/:magicLinkId',
    component: PlatformToolContainerComponent
  },
  {
    path: 'pcbc/scenarios/form/:FormId',
    component: PlatformLinkCreatorComponent,
    canActivate: [AuthGuard]
  },
  {
    path: 'pcbc/scenarios/:scenarioId/:magicLinkId',
    component: PlatformToolContainerComponent,
    canActivate: [AuthGuard]
  }
];
